import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { Suspense } from 'react';

import { AppShell } from './components/layout/AppShell';
import { LoadingScreen } from './components/common/LoadingScreen';
import { useAuth } from './hooks/useAuth';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { CustomersPage } from './pages/CustomersPage';
import { LicensesPage } from './pages/LicensesPage';
import { ValidationLogsPage } from './pages/ValidationLogsPage';
import { ProfilePage } from './pages/ProfilePage';

function ProtectedLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen message="Validating session..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

function ShellWrapper() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <ProtectedLayout />
    </Suspense>
  );
}

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    element: <ShellWrapper />,
    children: [
      { path: '/', element: <DashboardPage /> },
      { path: '/customers', element: <CustomersPage /> },
      { path: '/licenses', element: <LicensesPage /> },
      { path: '/validation-logs', element: <ValidationLogsPage /> },
      { path: '/profile', element: <ProfilePage /> }
    ]
  },
  { path: '*', element: <Navigate to="/" replace /> }
]);


